import React, { useEffect } from 'react';
import Context from '../_context';
import data from '../_context/state';
import styled, { ThemeProvider } from 'styled-components';
import Header from './header';
import Footer from './footer';
import { useLayout } from '../_hooks';
import LoaderScreen from '../_components/LoaderScreen';
import { Helmet } from "react-helmet"

const Layout = styled.div`
  overflow: hidden;
`

const Body = styled.div`
  position: relative;
  //padding-top: 67px;
  min-height: 100vh;
  @media(min-width: 768px){
    //padding-top: 89px;
  }
`

export default ({ children, data })=> {

  /*const { loading, data, error } = useLayout();

  if(loading) return <LoaderScreen />
  if(error) return <p>error de conexión</p>*/
  useEffect(()=>{
    (function () { var ldk = document.createElement('script'); ldk.type = 'text/javascript'; ldk.async = true; ldk.src = 'https://s.cliengo.com/weboptimizer/600889996dadce002a417694/60088c35e5c486002a01138a.js'; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ldk, s); })()
  },[]);

  useEffect(()=>{
    (
      async()=>{
        try{
          const data = await fetch(`https://api.clasihome.com/rest/builders?builderId=5ff6fdafef2456000816c0c8`);
          const result = await data.json();
          console.log("ORIGINAL DATA", result);
        }catch(e){
          console.log(e);
        }
      }
    )()
  },[])
  return(
    <Context.Provider value={data}>
      <ThemeProvider theme={data}>
        <Layout>
          <Helmet>
            <meta charSet="utf-8" />
            <meta name="description" content="Tenemos excelentes propiedades pensadas para ti." />
            <title>Benjamín Cousiño | Propiedades</title>
            <link rel="canonical" href="http://benjamincousinopropiedades.cl/" />
          </Helmet>              
          <Header />
          <Body>
            {children}
          </Body>
          <Footer />
        </Layout>
      </ThemeProvider>
    </Context.Provider>
  )
}